<template>
    <div>
        <div slot="title" :style="{'background':'#808695','color':'white','height':'35px'}">
            <div class="one-toolbar">
                <span class="spanRow"> 基本信息 </span>
                <el-link  :underline="false" @click="prevRec" v-if="v_idseq.length>1">
                    【 <span style="font-size:10px;margin-left:5px;color:white"> 上一条</span>】
                </el-link>
                <el-link  :underline="false" @click="nextRec"  v-if="v_idseq.length>1">
                    【 <span style="font-size:10px;margin-left:5px;color:white"> 下一条</span>】
                </el-link>
            </div>
        </div>  
        <div >
            <Form ref="addForm" :model="formCol" :label-width="120"   label-position="right" inline >
                <span v-for="(item,index) in tabArr" :key="index" >
                    <FormItem class="item-width"  :label="item.title" :prop="item.key" v-if="item.fhide==='N'">                                  
                        <el-input :placeholder="item.holder" :disabled="saveFlag" v-enter-number  v-if="item.edcss==='number'" v-model="formCol[item.key]" style="width:100%" ></el-input>   
                        <el-checkbox :disabled="saveFlag" border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="formCol[item.key]" style="width:100%"></el-checkbox> 
                        <el-date-picker :disabled="saveFlag" type="datetime"  v-else-if="item.edcss==='date'" v-model="formCol[item.key]" clearable value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" ></el-date-picker>     
                        <el-select :disabled="saveFlag" v-else-if="item.key==='CASHNO'" v-model="formCol[item.key]" style="width:100%" >
                            <span v-for="(item ,index) in cashArr" :key='index'>
                                <el-option :label="item.ACCNM" :value="item.IDSEQ" ></el-option>
                            </span>
                        </el-select>
                        <el-select :disabled="saveFlag" v-else-if="item.key==='PAYMTH'" v-model="formCol[item.key]" style="width:100%" >
                            <span v-for="(item ,index) in payArr" :key='index'>
                                <el-option :label="item.CNAME" :value="item.CODE" ></el-option>
                            </span>
                        </el-select>   
                        <el-select @change="wordChange" :disabled="saveFlag" v-else-if="item.key==='WORD'" v-model="formCol[item.key]" style="width:100%" >
                            <span v-for="(item ,index) in certArr" :key='index'>
                                <el-option :label="item.CNAME" :value="item.CODE" ></el-option>
                            </span>
                        </el-select>  
                        <el-input type="text" v-else-if="item.key==='ORIENT'" disabled v-model="formCol[item.key]">
                            <div slot="append">
                                <el-tooltip content="指示余额的方向： 余额大于0为借、小于0方向为贷、等于0为平" placement="bottom" effect="light">
                                    <el-button icon="iconfont icon-wenhaoxiao" style="width:50px;color:red"></el-button>
                                </el-tooltip>
                            </div>
                        </el-input>
                        <el-select   filterable :disabled="saveFlag" v-else-if="item.key==='EMPNO'" v-model="formCol[item.key]" style="width:100%" >
                            <span v-for="(item ,index) in empArr" :key='index'>
                                <el-option :label="item.EMPNM" :value="item.IDNO" ></el-option>
                            </span>
                        </el-select> 
                        <el-select filterable @change="orgChg" v-else-if="item.key==='ORGNM' " v-model="formCol[item.key]"   style="width:100%">
                            <el-row v-for="(item ,index) in orgArr " :key="index">
                                <el-col :span="4">
                                    <el-option  :label="item.TY" :value="item.EMPNM"></el-option>
                                </el-col>
                                <el-col :span="10">
                                    <el-option  :label="item.DEPTNM" :value="item.EMPNM"></el-option>
                                </el-col>
                                <el-col :span="10">
                                    <el-option  :label="item.EMPNM" :value="item.EMPNM"></el-option>
                                </el-col>
                            </el-row>
                        </el-select>
                        <!-- <el-input type="text" v-else-if="item.key==='ORGNM'" disabled v-model="formCol[item.key]">
                            <div slot="append">
                                <el-button @click="orgChoose" icon="iconfont icon-icon-choose" style="width:50px;color:blue;font-weight:600;font-size:22px;"></el-button>
                            </div>
                        </el-input> -->
                        <el-select filterable :disabled="saveFlag" v-else-if="item.key==='ACNO'" v-model="formCol[item.key]" style="width:100%" >
                            <span v-for="(item ,index) in acArr" :key='index'>
                                <el-option :label="item.CNAME" :value="item.IDSEQ" ></el-option>
                            </span>
                        </el-select> 
 
                        <el-input-number :precision="item.dotnum" style="width:100%" v-else-if="item.key=='BAMT'"  :disabled="bFlag||saveFlag" :class="bFlag?'yellow':''"  v-model="formCol[item.key]"></el-input-number>
                        <el-input-number :precision="item.dotnum" style="width:100%"  v-else-if="item.key=='DAMT'"  :disabled="aFlag||saveFlag" :class="aFlag?'yellow':''" v-model="formCol[item.key]"></el-input-number>
                        
                        <el-input :placeholder="item.holder" type="text" v-else :disabled="item.disabled==='Y'?true:false||saveFlag"  v-model="formCol[item.key]"></el-input>
                        <span slot="label" v-if="item.key==='DAMT'"><span style="color:red">{{item.title}}</span></span>
                        <span slot="label" v-else-if="item.key==='BAMT'"><span style="color:green">{{item.title}}</span></span>
                    </FormItem>
                </span>    
            </Form>   
            <div style="line-height:30px;border:1px solid #ccc;margin-bottom:6px; ">
                <el-button  class="button-new-tag" icon="iconfont icon-xinzeng" size="mini" type="text" plain @click="showInput">新增标签</el-button>
                <el-tag :key="index" v-for="(item,index) in tagArr" closable @close="tagClose(item)">{{item}}</el-tag>
                <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm">
                </el-input>  
            </div>
            <!-- 关联费用 -->
            <div class="one-toolbar">
                <span class="spanRow"> 关联费用明细 </span>
            </div>
            <el-table  :data="feeData" 
                border        
                class="custom-table-border"                    
                disabled-hover
                style="overflow:auto;margin-top:1px;"
                size="small"
                :height="180" 
                :cell-style="{padding:'2px'}"
                :row-key="getRowKey2"  
                ref="reffee" 
                highlight-current-row>
                <el-table-column type="index" label="序号" fixed></el-table-column>
                <span v-for="(item,index ) in feeArr" :key="index">
                    <el-table-column  v-if="item.thide==='N' &&item.key!=='SEL' "
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        sortable
                        :min-width="item.width">
                    </el-table-column> 
                </span>
                      
            </el-table> 
            <div class="one-toolbar">
                <span class="spanRow"> 凭证附件 </span>
            </div>
            <div style="display:flex" >
                <div style="display:flex;margin-left:30px;"  >
                    <span v-for="(item,index) in imgData" :key="index">  
                        <el-image :disabled="saveFlag" :preview-src-list="[item.FILEPATH]" fit="fill"  style="width:150px;height:125px;margin-right:30px;" :src="item.FILEPATH"></el-image>
                        <div style="height:25px;background:#e8eaec;width:150px; display:flex;justify-content:space-between">
                            <el-link :disabled="saveFlag" :underline="false" @click="imgDel(item.IDSEQ,item.LSTSEQ,item.FILEPATH,index)"><Icon type="md-close" /> 删除</el-link>
                            <!-- <el-link :underline="false" @click="imgPreview(item.FILEPATH)"><Icon type="ios-search" /> 预览</el-link> -->
                        </div>
                    </span>
                </div> 
            </div>
        </div>
 
   
        <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div> 
            <span>{{prompt}}</span>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="loadWin" width="50px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <el-image src="assets/authorize/loading.gif" fit="fill" style="height:30px;background:#F96161" ></el-image>
        </el-dialog>
        <el-dialog :visible.sync="showViewer" width="800px" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">预览</span>
            </div>
            <el-image fit="scale-down"  style=" margin:5px auto;height:500px;width:100% " :src="listurl"></el-image>
        </el-dialog>   
        <!-- 显示余额 -->
        <el-dialog :visible.sync="disWin" width="570px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">银行账户余额</span> 
            </div> 
            <span style="margin-left:5px;font-size:14px; color:red;font-weight:600">最近余额计算时间 : {{maxDttm}}</span>
            <div style="display:flex;line-height:40px;border-bottom:2px solid #409EFF">
                <div style="width:350px; ">银行账户名称</div>
                <div style="width:200px; ">账户实时余额</div>
            </div>
            <div style="display:flex;line-height:38px;border-bottom:1px solid #ccc" v-for="(item ,index) in cashArr" :key='index'>
                <div style="width:350px; ">{{item.ACCNM}}</div>
                <div style="width:200px; ">{{item.CURAMT}}</div>
            </div>
        </el-dialog> 
 
 
    </div>
</template>

<script>
 
  import { getTabColOrData,getBaseData } from '../../api/user'
  import {getDate} from '../../api/Select'
  export default {
    name: 'tmpl_bankday',
    components: {
 
    },
    data() {
      return {
        empArr:[],
        selAll:'N',
 
        refData:[],
        promptWin:false,
       
        showViewer:false,
        listurl:'',
        tagArr:[],
        inputVisible:false,
        inputValue:'',
        uploadData:{}, //上传数据
      
        prompt:'',
        addWin:false, //modal 
      
     
        
        dtlRow:{},
        acArr:[],
        formCol:{}, //表格单行记录 model
 
        bFlag:false,
        aFlag:false,
        v_acno:'',
        v_word:'',
 
        loadWin:false,
        typeFlag: 'create',
   
 
        dttm_:'',
        cashno:'',
        allData:[],
        tabData:[],
        tabArr:[],
        dtlArr:[],
        feeData:[],
        feeArr:[],
        saveFlag:false,
        v_url:'xuper_auth/getTableRecMany' , //api请求路径
        orgArr:[],
        addBool:false, //新增,为true时--禁止
        editBool:false, //编辑,为true时--禁止
        delBool:false, //删除 ,为true时--禁止
        cfmBool:false, //审核 ,为true时--禁止
        cancelBool:false, //作废 ,为true时--禁止 
        v_admin:this.$cookies.get('v_admin') ,//      
        v_username:this.$cookies.get('v_telno'), //api 请求用户
        
        v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
        dataCount:0,
        rowSize:50,
        goPage:'',
        maxDttm:'',
        prevFlag:false,
        nextFlag:false,
        payArr:[],
        notNull:[],
        cashArr:[],
        certArr:[],
        delArr:[],
        dtlIndex:'',
        current:1,
        stfgColor:'',
        stfgCss:'',
        imgData:[],
        disWin:false,
        v_k:0,
        operArr:[],
        v_idseq:[],
 
      }
    },
    created () {
        if(this.v_username){
  
            this.getTabField() // 字段集
         
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    mounted () {
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        getBaseData(this.v_url,'corpid',this.v_corpid,'','','V_FEE_EMP','').then(res=>{
            this.orgArr =res.result
        })
        getBaseData(this.v_url,'corpid',this.v_corpid,'','','v_hr_emp','').then(res=>{
            this.empArr =res.result
        })
        getBaseData(this.v_url,'corpid',this.v_corpid,'','','V_AC_iotype','').then(res=>{
            this.acArr =res.result
        })
 
 
        //资金账户选择
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'accty','14410','v_ac_account',' and stfg=\'Y\' order by sortby').then(res=>{
            this.cashArr =res.result
        })
        //凭证字
        getBaseData('xuper_auth/getBaseData','PARENTNO','4258','','','v_sys_base','').then(res=>{
            this.certArr =res.result
        })
 
        //结算方式
        getBaseData('xuper_auth/getBaseData','PARENTNO','4252','','','v_sys_base','').then(res=>{
            this.payArr =res.result
        })
      
    },
    computed:{
            scrollerHeight: function() {
                return (window.innerHeight - 90) + 'px';
            },
            tabHeight: function() {
                return (window.innerHeight - 170) + 'px';
            }, 
            tabWidth: function() {
                return (window.innerWidth - 100) + 'px';
            },
        },
    methods: {
        modal_exit(){
            this.addWin =false  
            this.$emit('child-exit')
        },
 
        showCalc(){
            this.disWin =true
        },
 
 
        //标签的赋予增加
        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus()
            })
        },
        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.tagArr.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
        },
        tagClose(tag) {
            this.tagArr.splice(this.tagArr.indexOf(tag), 1);
        },
        //图片预览
        imgPreview(path){
            this.showViewer=true
            this.listurl=path
        },
        //图片删除，操作数组
        imgDel(idseq,lstseq,path,index){
            this.$confirm('你确定要删除此图片吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:idseq,p_key2:'lstseq',p_value2:lstseq,p_key3:'filepath',p_value3:path,p_table:'mat_img'},
                }).then(res=>{      
                    if(res.code =='200')  {  
                        this.imgData.splice(index, 1);          
                    }else{
                        this.prompt=res.message
                        this.promptWin=true
                    }        
                })    
            }).catch(()=>{})
        },
 
        //查询图片数据
        qryImgData(idseq){
            getTabColOrData(this.v_url,'V_mat_img','PAYIDNO',idseq,'filety','IMG').then((res) => {
                this.imgData=[]
                if (res){
                    this.imgData =res.result
                }
            })
        },
 
        getFinData(idseq){
            this.$axios({    //select ${p_key2},max(gpno) gpno,count(1) cnt from ${p_table}
                method: 'post',
                url:this.v_url,
                data: {p_key2:'idno',p_value2:idseq,p_key:'corpid',p_value:this.v_corpid,  p_table:'V_fin_bank' },
            }).then(res=>{ 
                if (res.code==='200'){
                   
                    this.formCol=res.result[0] 
                }
            })
        },
 
        //查询凭证费用明细
        getFeeData(idseq){
            getTabColOrData(this.v_url,'V_FIN_BANKFEE','PAYBANKNO',idseq).then((res) => {
                this.feeData=[]
                this.feeData =res.result  
                this.$nextTick(()=>{
                    this.$refs.reffee.doLayout()
                })
            })
        },
 
        calcAmt(){
            this.dtlRow['AMT']=this.dtlRow['QTY']*this.dtlRow['PRC']
        },
 
 
        orgChg(val){
            // this.formCol['DEPTNO']=''
            // this.formCol['BANKADDR']=''         
            this.orgArr.some(item=>{
                if(item['EMPNM']==val){
                    this.formCol['ORGNO']=item['IDNO']
                }
            })
        },
 
        wordChange(val){
            if(val==='4259' ||val==='4263'){ //收、现收
                Object.assign(this.formCol,{'DAMT':''})
                this.aFlag=true  
                this.bFlag=false 
            }else if(val==='4260'||val==='4264' ){ //付、现付
                Object.assign(this.formCol,{'BAMT':''})
                this.bFlag=true
                this.aFlag=false   
            }else{
               this.bFlag=false
               this.aFlag=false 
            }
        },
        prevRec(){
            let v_len  =this.v_idseq.length
            this.saveFlag=true
            this.v_k =Number(this.v_k)-1
            if (this.v_k>=0) { 
                this.getFinData(this.v_idseq[this.v_k])
                //凭证明细  
                this.getFeeData(this.v_idseq[this.v_k]) //费用明细
                //产品图片
                this.qryImgData(this.v_idseq[this.v_k]) 
            }else{
                this.v_k =0
            }
        },
        nextRec(){
            let v_len  =this.v_idseq.length
            this.saveFlag=true
            this.v_k =Number(this.v_k)+1
            if (this.v_k<=v_len-1) { 
                this.getFinData(this.v_idseq[this.v_k])
                //凭证明细  
                this.getFeeData(this.v_idseq[this.v_k]) //费用明细
                //产品图片
                this.qryImgData(this.v_idseq[this.v_k]) 
            }else{
                this.v_k =v_len-1
            }
  
        },
        getRowKey2(row){
            return row.IDSEQ+'-'+row.LSTSEQ
        },
        initData(idseq){
            this.v_idseq =idseq.split(',')
            this.v_k =0
            //if (this.v_idseq.length>1) {
                this.saveFlag=true
                this.getFinData(this.v_idseq[0])
                //凭证明细  
                this.getFeeData(this.v_idseq[0]) //费用明细
                //产品图片
                this.qryImgData(this.v_idseq[0]) 
            //}
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','14445','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        holder:res.result[k].HOLDER,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','14445','lstseq','2','','',' order by sortby').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        holder:res.result[k].HOLDER,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','14445','lstseq','3','','',' order by sortby').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.feeArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
        }
    }
  }
</script>
<style scoped lang="less">
  .input-new-tag {
    width: 120px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .button-new-tag {
    margin-right: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
    .item-width  {
        width: 32%;
        color:red !important;
    } 
.headbar{
    padding-left:5px; 
    line-height:40px;
    background:#fff;
    overflow: auto;
    padding-top:2px;
    display:flex;
    border-left:2px solid #409eff;
}
.dtlbar{
    padding-left:5px; 
    line-height:35px;
    background:#808695;
    color: white;
    padding-top:4px;
    display:flex;
    border-left:2px solid #409eff;
}
.nodeLabel{
        font-size:12px;
        font-weight:500;
        padding-left:10px;
        color: black;
    }
.nodeRoot{
        width:20px;
        font-size:14px;
        font-weight:600;
    }  
    .top{
        padding: 10px;
        background: rgba(0, 153, 229, .7);
        color: #fff;
        text-align: center;
        border-radius: 2px;
    } 
     .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }       
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{  //用于表格中checkbox disabled时为蓝色
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: #f3b6b6 !important;
      color:rgb(30, 44, 90);
    }
    .el-tree-node__content:hover {    
      background-color: #66b1ff87;
    }
    .tree-scroll{
        width :180px;
        border: 1px solid #f5dbdb;
        height: 100%;
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
    .yellow .el-input__inner {
        background-color: #f5d9b1;    //橙色
    }
    .el-tag  {
        margin-left: 10px;
    }
</style>
